declare namespace $ {

	type $mol_paragraph__title_easyreels_user_quota_1 = $mol_type_enforce<
		ReturnType< $easyreels_user_quota['text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_portion__portion_easyreels_user_quota_2 = $mol_type_enforce<
		ReturnType< $easyreels_user_quota['ratio'] >
		,
		ReturnType< $mol_portion['portion'] >
	>
	export class $easyreels_user_quota extends $mol_view {
		text( ): string
		Text( ): $mol_paragraph
		ratio( ): number
		Bar( ): $mol_portion
		used_bytes( ): number
		limit_bytes( ): number
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=quota.view.tree.d.ts.map